<template>
  <div v-if="confirmation" class="password-match-hint" :class="matchClass">
    <b-icon :icon="matches ? 'check-circle-fill' : 'x-circle-fill'" />
    <span class="ml-1">{{
      matches ? 'Passwords match' : "Passwords don't match"
    }}</span>
  </div>
</template>

<script>
import { passwordsMatch } from '@/utils/passwordPolicy'

export default {
  name: 'PasswordMatchHint',
  props: {
    password: {
      type: String,
      default: '',
    },
    confirmation: {
      type: String,
      default: '',
    },
  },
  computed: {
    matches() {
      return passwordsMatch(this.password, this.confirmation)
    },
    matchClass() {
      return this.matches ? 'text-success' : 'text-danger'
    },
  },
}
</script>

<style lang="scss" scoped>
.password-match-hint {
  font-size: 0.85rem;
  line-height: 1.6;
}
</style>
